import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.94497 5.52925C0.553352 5.91993 0.333354 6.44974 0.333354 7.00216C0.333354 7.55459 0.553352 8.0844 0.94497 8.47508L1.2416 8.77091L6.14646 13.6667L9.70186 13.6667L4.27058 8.25008L13.6667 8.25008L13.6667 5.75008L4.27058 5.75008L9.70186 0.333415L6.14646 0.333414L1.2416 5.22925L0.94497 5.52925Z",
		fill: "#100118"
	})
});
export default SvgArrowLeftLong;
